export const getOperationalHoursState = ({ operationalHours }) => operationalHours
export const getRecommendedCreneauListState = (state) =>
  getOperationalHoursState(state).recommendedCreneauList

export const getIsLoadingRecommendedCreneau = (state) =>
  getOperationalHoursState(state).isLoadingRecommendedCreneau
